import { setConfig, GovernFunction } from 'owa-bundling-light';
import markImportAsLoaded from './mutators/markImportAsLoaded';
import isImportLoaded from './selectors/isImportLoaded';
import type { LogUsageFunction } from 'owa-analytics-types';
import { errorThatWillCauseAlert, trace } from 'owa-trace';

export function setBundlingConfig(logUsage: LogUsageFunction, govern: GovernFunction) {
    setConfig({
        markImportAsLoaded,
        isImportLoaded,
        logUsage,
        logError: errorThatWillCauseAlert,
        govern,
        trace: (message: string) => trace.info(message, 'bundling'),
    });
}
